module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 1.ae3b5b1c.png";